import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RecordingIndex } from '@/pages/recording/RecordingIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const recordingsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	status: z.enum(['COMPLETE', 'RECORDING', 'GENERATING_THUMBNAIL']).optional(),
	sortDirection: z.enum(['asc', 'desc']).default('desc'),
});

export const Route = createFileRoute('/_authenticated/_app/recording')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['recordings.read.own', 'recordings.read.all'], redirectTo: '/dashboard' }),
	component: RecordingIndex,
	validateSearch: recordingsSearchSchema,
});
